<template lang="pug">
v-layout#layout-login
    v-flex.xs12.sm5.offset-sm4
        v-card.card-login.px-5.pt-5.pb-4
            //v-card-title(primary-title='')
            div.flex.s12
                h3.headline.mb-0 Iniciar Sesión
                    v-form(ref="form")
                        v-layout(row wrap)
                            v-flex.xs12
                                RUTInput(
                                  v-model='rut'
                                  label='RUT'
                                  required
                                  ref="rut"
                                  :rules="[rules.required]"
                                  :color="colors.primary")
                            v-flex.xs12
                                v-text-field.pt-4.pb-3(
                                  type="password"
                                  v-model='password'
                                  label='Contraseña'
                                  required
                                  ref="pass"
                                  :rules="[rules.required]"
                                  :color="colors.primary"
                                  :error-messages="error"
                                  @keyup.enter="login")
                            v-flex.xs6
                                v-checkbox(
                                  v-model='remember_me'
                                  label='Recordarme'
                                  )
                            v-flex.xs6.pt-1
                                v-btn.ml-0(
                                  type="button"
                                  color='success'
                                  v-on:click="login"
                                  block
                                  ) Entrar
                            v-flex.xs12.text-xs-right
                                router-link.body-1(
                                  tag='span'
                                  to='/password/email')
                                    a Recuperar Contraseña
</template>

<script>
import { mapActions } from 'vuex'
import colors from '@/mixins/Colors'
import RUTUtils from '@/mixins/RUTUtils'
import { required, email, minLength } from 'vuelidate/lib/validators'
import RUTInput from '@/components/RUTInput/RUTInput.vue'

// Custom validate functions
const rutValido = function(rut) {
    return this.mixValidateRUT(rut)
}

export default {
    name: 'login',
    components: { RUTInput },
    data: () => {
        return {
            rut: localStorage.getItem('remember-me') || '',
            password: '',
            remember_me: !!localStorage.getItem('remember-me'),
            bRejectLoginByServer: false,
            error: null,
        }
    },
    mixins: [RUTUtils],
    watch: {
        rut: function(newVal) {
            this.mixRUTInputHandler(newVal)
        },
    },
    computed: {
        rules() {
            let dv = this.mixDV
            return {
                required: v => !!v || 'Campo Obligatorio',
                rut(v) {
                    if (v.length < 3) return 'RUT no válido'
                    if (!v.includes('-')) return 'Sin puntos, con guión'
                    let rut = v
                        .split('.')
                        .join('')
                        .split('-')
                    if (dv(rut[0]) !== parseInt(rut[1])) return 'RUT no válido'
                    return true
                },
            }
        },
    },
    methods: {
        ...mapActions('AuthModule', {
            loginRequestAction: 'loginRequestAction',
        }),
        login: function() {
            if (this.$refs.form.validate()) {
                let { rut, password, remember_me } = this
                this.loginRequestAction({ rut, password, remember_me })
                    .then(() => {
                        this.$router.push('/')
                    })
                    .catch(err => {
                        this.error =
                            err.response.status === 422
                                ? `Rut o contraseña incorrectos`
                                : err.response && err.response.data
                                    ? err.response.data.message
                                    : err
                        this.bRejectLoginByServer = true
                    })
            }
        },
    },
    mounted() {
        document.title = 'Login - Agroplastic'
        console.log(localStorage.getItem('remember-me') ? 'pass' : 'rut')
        console.log(
            this.$refs[localStorage.getItem('remember-me') ? 'pass' : 'rut']
        )
        this.$nextTick(() => {
            this.$refs[
                localStorage.getItem('remember-me') ? 'pass' : 'rut'
            ].focus()
        })
    },
}
</script>
    
<style lang="scss" scoped>
#layout-login {
    /* Bg Image */
    background-image: url('../../assets/bg-agro.jpg');
    background-size: 100% 100%;
}

#layout-login::before {
    content: '';
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    width: 100%;
    height: 100%;
}

.card-login {
    margin-top: 60px;
    background-color: rgba(255, 255, 255, 0.85) !important;
}

a {
    color: darkcyan;
}
</style>
